<template>
    <div>
        <b-card :title="`${$route.params.id}  Attribute`">
            <!-- <pre>{{ products }}</pre> -->
            <b-row>
                <template v-for="(item, index) in products">

                    <b-col cols="6" class="mb-3" :key="index" >
                        <b-form-group :label="item.name">
                            <b-form-select @change="getPricing()" size="sm" v-model="item.selected" :options="item.options">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </template>
            </b-row>
        </b-card>
        <b-card :title="`${$route.params.id}  Pricing`">
            <pre>{{ pricing }}</pre>
        </b-card>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            attributes: null,
            products: null,
            pricing: null
        };
    },
    mounted() {
        this.getProductAttribute();
    },
    methods: {
        async getProductAttribute() {
            let loader = this.$loading.show({
                loader: "dots",
            });
            try {
                const resp = await this.$store.getters.client.get(`/solopress/attribute/${this.$route.params.id}`)
                this.products = resp.data
                console.log(this.products)
                this.attributes = resp.data.attribute_values
                this.products = Object.entries(resp.data.attribute_values).reduce((acc, [key, value]) => {
                    if (Array.isArray(value) && value.length > 0) {
                        acc.push({
                            name: key,
                            options: value,
                            selected: value[0], // Or set a default selected value if needed
                        });
                    }
                    return acc;
                }, []);

                console.log(this.products);
            } catch (error) {
                alert(error)
            } finally {
                loader.hide()
            }
        },
        async getPricing() {
            let loader = this.$loading.show({
                loader: "dots",
            });
            const payload = {
                ...this.products.reduce((acc, item) => {
                    acc[item.name] = item.selected;
                    return acc;
                }, {}),
                // ...this.attributes,
                quantity: 250,
                product: this.$route.params.id
            }
            try {
                const resp = await axios.post('https://apistaging.solopress.com/api/v2/price/matrix', payload)
                console.log(resp.data)
            } catch (error) {
                alert(error)
            } finally {
                loader.hide()
            }
        },
    }
}
</script>